import { enum as permissions } from '../../../../../../../enums/admin-permissions';

const isEverad = process.env.CPA_ENV === 'everad';

const icons = {
	view: 'icon-view',
	create: 'icon-create',
	delete: 'icon-delete',
	update: 'icon-update',
	approve: 'icon-approve',
	confirm: 'icon-confirm',
	answer: 'icon-answer',
	close: 'icon-close',
	grantAccess: 'icon-grant-access',
	other: 'icon-other',
	list: 'icon-list'
};

const actions = {
	view: 'View',
	create: 'Create',
	update: 'Update',
	approve: 'Approve',
	confirm: 'Confirm',
	answer: 'Answer',
	close: 'Close',
	grantAccess: 'Grant access',
	delete: 'Delete'
};

const threadRules = [{
	name: actions.view,
	icon: icons.view,
	key: permissions.threadsList
}, {
	name: actions.create,
	icon: icons.create,
	key: permissions.threadsCreate
}, {
	name: actions.answer,
	icon: icons.answer,
	key: permissions.threadsAnswer
}, {
	name: actions.close,
	icon: icons.close,
	key: permissions.threadsClose
}, {
	name: `Threads list exclude personal`,
	icon: icons.view,
	key: permissions.threadsListExcludePersonal
}, {
	name: `Threads list only personal`,
	icon: icons.view,
	key: permissions.threadsListOnlyPersonal
}];

export default [{
	moduleName: 'Admins',
	moduleKey: 'admins',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.adminsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.adminsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.adminsDelete
	}, {
		name: 'Set global permissions',
		icon: icons.update,
		key: permissions.adminsSetGlobalPermissions
	}]
}, {
	moduleName: 'Analytics',
	moduleKey: 'analytics',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.analyticsView
	}, {
		name: 'Change conversion statuses',
		icon: icons.update,
		key: permissions.changeConversionStatuses
	}, {
		name: 'View extended stat',
		icon: icons.view,
		key: permissions.analyticsViewExtendedStat
	}, {
		name: 'View conversions profit',
		icon: icons.view,
		key: permissions.analyticsViewConversionsProfit
	}, {
		name: 'View autotrash',
		icon: icons.view,
		key: permissions.autotrashView
	}, {
		name: 'Resend autotrash',
		icon: icons.update,
		key: permissions.autotrashResend
	}, {
		name: 'View promo report',
		icon: icons.view,
		key: permissions.promoReportView
	}]
}, {
	moduleName: 'Affiliate Managers Productivity',
	moduleKey: 'affiliateManagersProductivity',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.affiliateManagersProductivityListAll
	}, {
		name: 'View personal productivity',
		icon: icons.view,
		key: permissions.affiliateManagersProductivityShowMe
	}, {
		name: 'View traffic accounting',
		icon: icons.view,
		key: permissions.trafficAccountingView
	}]
}, {
	moduleName: 'Affiliates',
	moduleKey: 'affiliates',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.affiliatesList
	}, {
		name: 'Download list',
		icon: icons.view,
		key: permissions.affiliatesListDownload
	}, {
		name: 'Update feature flags',
		icon: icons.update,
		key: permissions.affiliatesUpdateFeatureFlags
	}, {
		name: 'View affiliate ids',
		icon: icons.view,
		key: permissions.affiliateIdsList
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.affiliatesUpdate
	}, {
		name: 'Register affiliate',
		icon: icons.other,
		key: permissions.registerAffiliate
	}, {
		name: 'Login with affiliate',
		icon: icons.other,
		key: permissions.loginWithAffiliate
	}, {
		name: 'View activity',
		icon: icons.view,
		key: permissions.affiliatesActivityList
	}, {
		name: 'View managers/affs activity',
		icon: icons.view,
		key: permissions.managersAffiliatesActivity
	}, {
		name: 'View registration analytics',
		icon: icons.view,
		key: permissions.registrationAnalytics
	}, {
		name: 'View marketing funnel',
		icon: icons.view,
		key: permissions.marketingFunnel
	}, {
		name: 'View redeem',
		icon: icons.view,
		key: permissions.affiliatesRedeemList
	}, {
		name: 'Transfer points',
		icon: icons.update,
		key: permissions.transferPoints
	}, {
		name: 'Transactions create',
		icon: icons.create,
		key: permissions.transactionsCreate
	}, {
		name: 'Delete sessions',
		icon: icons.delete,
		key: permissions.sessionsDelete
	}, {
		name: 'Top Countries view all',
		icon: icons.view,
		key: permissions.topCountriesViewAll
	}, {
		name: 'Top Countries view profits',
		icon: icons.view,
		key: permissions.topCountriesViewAllProfits
	}, {
		name: 'Top affiliates & Countries',
		icon: icons.view,
		key: permissions.topAffiliatesViewAll
	}, {
		name: 'Top affs copy total',
		icon: icons.view,
		key: permissions.canCopyTotalRow
	}].concat(process.env.CPA_ENV === 'everad' ? {
		name: 'Add lead source',
		icon: icons.create,
		key: permissions.addLeadSource
	} : [{
		name: 'Transfer accumulated points',
		icon: icons.update,
		key: permissions.transferBalanceAndAccumulatedPoints
	}])
}, {
	moduleName: 'Affiliate money transfer',
	moduleKey: 'AffiliateMoneyTransfer',
	rules: [{
		name: 'Transfer between affiliates',
		icon: icons.view,
		key: permissions.transferMoneyBetweenAffiliates
	}, {
		name: 'Exchange affiliate money',
		icon: icons.view,
		key: permissions.currencyExchange
	}, {
		name: 'Transfer prize money',
		icon: icons.view,
		key: permissions.transferPrizeMoney
	}, {
		name: 'Transfer adjustment money',
		icon: icons.view,
		key: permissions.transferAdjustmentMoney
	}].concat(process.env.CPA_ENV === 'everad' ? [{
		name: 'Transfer hidden money',
		icon: icons.view,
		key: permissions.transferHiddenMoney
	}] : [])
},	{
	moduleName: 'Payout systems',
	moduleKey: 'payoutSystems',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.payoutSystemsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.payoutSystemsCreate
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.payoutSystemsUpdate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.payoutSystemsDelete
	}, {
		name: 'View balances',
		icon: icons.view,
		key: permissions.payoutSystemsGetBalance
	}, {
		name: 'Change display priority',
		icon: icons.list,
		key: permissions.payoutSystemsChangeDisplayPriority
	}]
}, {
	moduleName: 'Payouts',
	moduleKey: 'payouts',
	subPermission: {
		moduleName: 'Systems',
		moduleKey: 'payouts-approve-list',
		relationRule: permissions.payoutsList
	},
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.payoutsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.payoutsCreate
	}, {
		name: actions.approve,
		icon: icons.approve,
		key: permissions.payoutsApprove
	}, {
		name: actions.confirm,
		icon: icons.confirm,
		key: permissions.payoutsConfirm
	}, {
		name: 'Change urgency',
		icon: icons.update,
		key: permissions.payoutsChangeUrgency
	}, {
		name: 'Change auto confirm settings',
		icon: icons.confirm,
		key: permissions.payoutsChangeAutoConfirmSettings,
		getIsHidden:  () => !(window.globalConfig && window.globalConfig.isAutomaticPayoutConfirmationAbilityEnabled)
	}]
}, {
	moduleName: 'Exchange rates',
	moduleKey: 'exchangeRates',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.exchangeRatesList
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.exchangeRatesUpdate
	}]
}, {
	moduleName: 'Landings Snippets',
	moduleKey: 'landingSnippets',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.landingsSnippetsList
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.landingsSnippetsUpdate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.landingsSnippetsDelete
	}]
}, {
	moduleName: 'Campaign domain',
	moduleKey: 'campaignDomain',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.campaignDomainsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.campaignDomainsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.campaignDomainsDelete
	}]
}, {
	moduleName: 'Threads',
	moduleKey: 'threads',
	rules: (process.env.CPA_ENV === 'everad')
		? threadRules
		: threadRules.concat({
			name: `${actions.close} (gift order)`,
			icon: icons.close,
			key: permissions.threadsGiftOrderClose
		})
}, {
	moduleName: 'External Threads',
	moduleKey: 'extThreads',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.extThreadsList
	}, {
		name: actions.answer,
		icon: icons.answer,
		key: permissions.extThreadsAnswer
	}, {
		name: actions.close,
		icon: icons.close,
		key: permissions.extThreadsClose
	}]
}, {
	moduleName: 'Offers',
	moduleKey: 'offers',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.offersList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.offersCreate
	}, {
		name: actions.grantAccess,
		icon: icons.grantAccess,
		key: permissions.offersGrant
	}, {
		name: 'View all top offers',
		icon: icons.view,
		key: permissions.topOffersViewAll
	}, {
		name: 'View with removed',
		icon: icons.view,
		key: permissions.offersListRemoved
	}, {
		name: 'List export',
		icon: icons.view,
		key: permissions.offersListExport
	}].concat(isEverad ? [{
		name: 'Can change capacity',
		icon: icons.view,
		key: permissions.offersChangeCap
	}] : [])
}, {
	moduleName: 'News',
	moduleKey: 'news',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.newsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.newsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.newsDelete
	}]
}, {
	moduleName: 'Mailings',
	moduleKey: 'mailings',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.mailingsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.mailingsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.mailingsDelete
	}]
}, {
	moduleName: 'Defined Referers',
	moduleKey: 'definedReferers',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.definedReferersList
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.definedReferersUpdate
	}]
}, {
	moduleName: 'Campaigns',
	moduleKey: 'campaigns',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.campaignsList
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.campaignsEdit
	}]
}, {
	moduleName: 'Polls',
	moduleKey: 'polls',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.pollsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.pollsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.pollsDelete
	}]
}, {
	moduleName: 'WM',
	moduleKey: 'wm',
	rules: [{
		name: 'Work with WM',
		icon: icons.confirm,
		key: permissions.wm
	}]
}, {
	moduleName: 'Advertisers Requests',
	moduleKey: 'advRequests',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.advRequestList
	}]
}, {
	moduleName: 'Conversions Approve',
	moduleKey: 'conversionsApprove',
	rules: [{
		name: 'Manual approve',
		icon: icons.update,
		key: permissions.conversionsManualApprove
	}, {
		name: 'Approve requests',
		icon: icons.view,
		key: permissions.manualApproveRequests
	}, {
		name: 'Approve req. confirm',
		icon: icons.update,
		key: permissions.manualApproveRequestsConfirm
	}, {
		name: 'Past manual approve',
		icon: icons.update,
		key: permissions.conversionsPastManualApprove
	}, {
		name: 'Auto approve daily',
		icon: icons.update,
		key: permissions.conversionsApproveDaily
	}, {
		name: 'Register view+add guarants',
		icon: icons.view,
		key: permissions.guarantRegisterView
	}, {
		name: 'Garant forecast',
		icon: icons.view,
		key: permissions.garantForecastView
	}, {
		name: 'Guarant register prolong',
		icon: icons.update,
		key: permissions.guarantRegisterConfirmProlong
	}, {
		name: 'Garant requests view',
		icon: icons.view,
		key: permissions.garantApproveRequestsView
	}, {
		name: 'Garant requests approve',
		icon: icons.update,
		key: permissions.garantApproveRequestsApprove
	}]
}, {
	moduleName: 'Fin reports',
	moduleKey: 'finReports',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.finReportsView
	}, {
		name: 'View manual adjustments',
		icon: icons.view,
		key: permissions.manualAdjustmentsView
	}]
}, {
	moduleName: 'Landing reports',
	moduleKey: 'landingReports',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.landingReportsView
	}]
}, {
	moduleName: 'Marketing reports',
	moduleKey: 'marketingReports',
	rules: [{
		name: 'View points report',
		icon: icons.view,
		key: permissions.viewMarketingReports
	}]
}, {
	moduleName: 'Payout log',
	moduleKey: 'payoutLogs',
	rules: [{
		name: 'View payout log',
		icon: icons.view,
		key: permissions.payoutLogView
	}]
}, {
	moduleName: 'Discounts',
	moduleKey: 'discount',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.discountsList
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.discountsCreate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.discountsDelete
	}]
}, {
	moduleName: 'Goods',
	moduleKey: 'goods',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.goodsView
	}, {
		name: actions.create,
		icon: icons.create,
		key: permissions.goodsCreate
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.goodsUpdate
	}, {
		name: actions.delete,
		icon: icons.delete,
		key: permissions.goodsDelete
	}]
}, {
	moduleName: 'BM accounts',
	moduleKey: 'bmAccounts',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.bmAccountsView
	}, {
		name: actions.update,
		icon: icons.update,
		key: permissions.bmAccountsUpdate
	}]
}, {
	moduleName: 'Missions and achievements',
	moduleKey: 'missions',
	isHidden: process.env.CPA_ENV === 'rocket',
	rules: [{
		name: 'View missions',
		icon: icons.view,
		key: permissions.missionsView
	}, {
		name: 'Update missions',
		icon: icons.update,
		key: permissions.missionsUpdate
	}, {
		name: 'View achievements',
		icon: icons.view,
		key: permissions.achievementsView
	}, {
		name: 'Update achievements',
		icon: icons.update,
		key: permissions.achievementsUpdate
	}]
}, {
	moduleName: 'Configs',
	moduleKey: 'contests',
	rules: [{
		name: 'View',
		icon: icons.other,
		key: permissions.contestView
	}, {
		name: 'Edit',
		icon: icons.other,
		key: permissions.contestEdit
	}]
}, {
	moduleName: 'Banners',
	moduleKey: 'banners',
	rules: [{
		name: 'Work with banners',
		icon: icons.other,
		key: permissions.banners
	}]
}, {
	moduleName: 'Affiliate reports',
	moduleKey: 'affiliateReports',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.affiliateReportsView
	}, {
		name: 'Affiliate monthly report view',
		icon: icons.view,
		key: permissions.affiliateMonthlyReportView
	}]
}, {
	moduleName: 'CPL Rules',
	moduleKey: 'cpl-rules',
	rules: [{
		name: 'View',
		icon: icons.other,
		key: permissions.cplRulesList
	}, {
		name: 'Edit',
		icon: icons.other,
		key: permissions.cplRulesEdit
	}]
}, {
	moduleName: 'Approved Rejected Payouts',
	moduleKey: 'approvedRejectedPayouts',
	rules: [{
		name: 'View',
		icon: icons.other,
		key: permissions.approvedRejectPayoutsList
	}, {
		name: 'Edit',
		icon: icons.other,
		key: permissions.approvedRejectPayoutsEdit
	}]
}, {
	moduleName: 'Restricted geo payout rates',
	moduleKey: 'geoPayoutRates',
	rules: [{
		name: 'View',
		icon: icons.other,
		key: permissions.geoPayoutRatesList
	}, {
		name: 'Edit',
		icon: icons.other,
		key: permissions.geoPayoutRatesEdit
	}]
}, {
	moduleName: 'Manager reports',
	moduleKey: 'managerReports',
	rules: [{
		name: 'Alerts analytics',
		icon: icons.other,
		key: permissions.alertsAnalytics
	}, {
		name: 'Work with product cap',
		icon: icons.other,
		key: permissions.productCap
	}, {
		name: 'Work with priorities',
		icon: icons.other,
		key: permissions.priorities
	}, {
		name: 'Weekly report',
		icon: icons.other,
		key: permissions.weeklyReport
	}, {
		name: 'Quids report',
		icon: icons.other,
		key: permissions.quidsReport
	}]
}, {
	moduleName: 'Payout requests',
	moduleKey: 'payout_requests',
	rules: [{
		name: 'View personal',
		icon: icons.view,
		key: permissions.payoutRequestsViewPersonal
	}, {
		name: 'View all',
		icon: icons.view,
		key: permissions.payoutRequestsViewAll
	}, {
		name: 'View matrix and history',
		icon: icons.view,
		key: permissions.payoutRequestsViewMatrixAndHistory
	}, {
		name: 'Manager role',
		icon: icons.update,
		key: permissions.payoutRequestsManagerRole
	}, {
		name: 'Review',
		icon: icons.update,
		key: permissions.payoutRequestsReview
	}, {
		name: 'Confirm',
		icon: icons.update,
		key: permissions.payoutRequestsConfirm
	}]
}].concat((process.env.CPA_ENV === 'everad') ? [{
	moduleName: 'Total debt',
	moduleKey: 'totalDebt',
	rules: [{
		name: 'View',
		icon: icons.other,
		key: permissions.totalDebtView
	}]
}, {
	moduleName: 'Affiliate CRM',
	moduleKey: 'affiliateCRM',
	rules: [{
		name: 'Update config',
		icon: icons.update,
		key: permissions.affiliateCrmEditConfig
	}, {
		name: 'Create tasks',
		icon: icons.update,
		key: permissions.affiliateCrmCreateTasks
	}, {
		name: 'View all pages',
		icon: icons.update,
		key: permissions.affiliateCrmEditConfigViewAllPages
	}]
}] : [{
	moduleName: 'Ranks & QUIDs',
	moduleKey: 'ranksPointsReport',
	rules: [{
		name: actions.view,
		icon: icons.view,
		key: permissions.ranksPointsReport
	}]
}, {
	moduleName: 'Popups',
	moduleKey: 'popups',
	rules: [{
		name: 'Work with popups',
		icon: icons.other,
		key: permissions.popups
	}]
}, {
	moduleName: 'Blog',
	moduleKey: 'blog',
	rules: [{
		name: 'Work with blog',
		icon: icons.other,
		key: permissions.blog
	}]
}]);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/permissions/config.js